var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDesktopLogoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 14.8777L14.8797 2.92773",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1016 17.2771L11.3016 16.0771",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.793 14.5873L15.183 12.1973",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60127 9.23754L9.24127 2.59754C11.3613 0.477536 12.4213 0.467536 14.5213 2.56754L19.4313 7.47754C21.5313 9.57754 21.5213 10.6375 19.4013 12.7575L12.7613 19.3975C10.6413 21.5175 9.58127 21.5275 7.48127 19.4275L2.57127 14.5175C0.47127 12.4175 0.47127 11.3675 2.60127 9.23754Z",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.9961H21",
    stroke: "#999CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDesktopLogoBlue);
export default __webpack_public_path__ + "static/media/cardDesktopLogoBlue.0a25e8e1d1dc1e3dd69977a56206f095.svg";
export { ForwardRef as ReactComponent };